import React, {useEffect, useState } from 'react';
import { CdsFieldLabel, useFormContext } from 'clayco-component-library/lib';
import { Form } from 'react-bootstrap';

// If this will be resused elsewhere, put it in the Component Library
const AreaCodeInput = ({label, required = false, maxLength = 3, key, value,
  onChange,
  helpText,
  pattern,
  placeholder,
  name,
  initialValue = '',
  optionalValidityText,
  autoComplete = 'off',
  international = false,
  controlled = false,
  disabled = false,
  showTooltip = false,
  before,
  after,
  classes
 }) => {
    const tooltipHeader = "";
    const tooltipBody = <></>;    
    const type = "";

    maxLength = international ? 8 : maxLength;

    const { register, watch, formState, setValue, trigger } = useFormContext()

    const [objValue, setObjValue] = useState(null)
    const watcher = watch(name)
    let obj = formState.errors[name]
  
    const array = name.substr(0, name.indexOf('['))
    if (array.length > 0) {
      const optionalName = name.replace('.', '?.')
      obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null
    }

    const refreshObj = () => {
        if (array.length > 0) {
          const optionalName = name.replace('.', '?.')
          obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null
        }
      }


    useEffect(() => {
        if (!watcher) setObjValue(null)
        else setObjValue(watcher)
    
        refreshObj()
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [watcher])

    useEffect(() => {
      if (initialValue != null) {
            setValue(name, initialValue)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

      const change = (e) => {
        // clear custom validity so that it can properly reassess
        e.currentTarget.setCustomValidity('');

        // for US ensure numbers only for area code
        if (international){
          var val = e.target.value;
          val = val[0] === "+" ? val : val = "+" + val;
          setValue(name, val);
        }
        else
          e.target.value = e.target.value.replace(/[^0-9]/g, '');

        if (e)
            setValue(name, e.target.value);

        if (onChange)
            onChange(e.target.value);

        trigger(name);
      };

    return(
        <>
        <div className="area-code-field">
            <Form.Group>
                <CdsFieldLabel label={label || ''} required={required} showTooltip={showTooltip} tooltipHeader={tooltipHeader} tooltipBody={tooltipBody} />
                <div className="input-group">
                    {before && <span className="input-group-text">{before}</span>}
                    {/* 
                        If CdsInputField is specified as controlled={true},
                        then the value prop will be passed down to the component.
                        Otherwise, no value prop is passed down to the
                        uncontrolled component.
                    */}
                    {
                        controlled ?
                       <Form.Control
                        key={key}
                        value={value}
                        autoComplete={autoComplete}
                        className={classes}
                        required={required}
                        placeholder={placeholder}
                        type={type}
                        pattern={pattern}
                        {...register(name)}
                        isInvalid={!!obj}
                        disabled={disabled}
                        onChange={change}
                        maxLength={maxLength}
                        onInvalid={
                          (e)=> optionalValidityText ? 
                          e.currentTarget.setCustomValidity(optionalValidityText) :
                          e.currentTarget.setCustomValidity('')}
                      ></Form.Control>
                      :
                      <Form.Control
                        key={key}
                        autoComplete={autoComplete}
                        className={classes}
                        required={required}
                        placeholder={placeholder}
                        type={type}
                        pattern={pattern}
                        {...register(name)}
                        isInvalid={!!obj}
                        disabled={disabled}
                        onChange={change}
                        maxLength={maxLength}
                        onInvalid={
                          (e)=> optionalValidityText ? 
                          e.currentTarget.setCustomValidity(optionalValidityText) :
                          e.currentTarget.setCustomValidity('')}
                      ></Form.Control>  }
                      {after && <span className="input-group-text">{after}</span>}
                    </div>
                    <Form.Text className="cds-text-light-italic">{helpText}</Form.Text>
                    <Form.Control.Feedback type="invalid">{obj?.message}</Form.Control.Feedback>
            </Form.Group>
        </div>
        </>
    )
}

export default AreaCodeInput;